if(!window.requestIdleCallback){window.requestIdleCallback=function(cb){var s=Date.now();return setTimeout(function(){cb({didTimeout:false,timeRemaining:function(){return Math.max(0,50-(Date.now()-s))}})},1)};window.cancelIdleCallback=function(i){clearTimeout(i)};}
(function(){
  var d=document, root=d.documentElement;
  root.classList.add('f-js');
  var hg=d.getElementById('header-group');
  function measure(){ if(!hg) return; var h=hg.getBoundingClientRect().height; var top=hg.classList.contains('is-scrolled')?0:h; if(!hg.classList.contains('is-scrolled')){ root.style.setProperty('--f-hg-h',Math.round(h)+'px'); }
    d.body.style.setProperty('--header-height',Math.round(h)+'px'); d.body.style.setProperty('--header-group-height',Math.round(h)+'px'); }
  function onScroll(){ if(!hg) return; var s=(window.scrollY||root.scrollTop)>24; if(s!==hg.classList.contains('is-scrolled')){ hg.classList.toggle('is-scrolled',s); } }
  window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',measure);
  function init(){
    measure(); onScroll();
    // hero bottles: size hit areas to the visible silhouette
    d.querySelectorAll('.f-bottle').forEach(function(a){
      var im=a.querySelector('img'); if(!im) return;
      var go=function(){
        var t=new Image(); t.crossOrigin='anonymous';
        t.onload=function(){ try{
          var w=160,h=Math.round(w*t.naturalHeight/t.naturalWidth),c=d.createElement('canvas'); c.width=w; c.height=h;
          var x=c.getContext('2d'); x.drawImage(t,0,0,w,h); var px=x.getImageData(0,0,w,h).data;
          var x0=w,x1=0,y0=h,y1=0;
          for(var y=0;y<h;y++){for(var i=0;i<w;i++){ if(px[(y*w+i)*4+3]>40){ if(i<x0)x0=i; if(i>x1)x1=i; if(y<y0)y0=y; if(y>y1)y1=y; } }}
          if(x1<=x0||y1<=y0) return;
          a.style.setProperty('--hit-l',(x0/w*100).toFixed(1)+'%'); a.style.setProperty('--hit-r',((1-(x1+1)/w)*100).toFixed(1)+'%');
          a.style.setProperty('--hit-t',(y0/h*100).toFixed(1)+'%'); a.style.setProperty('--hit-b',((1-(y1+1)/h)*100).toFixed(1)+'%');
        }catch(e){} };
        t.src=im.currentSrc||im.src;
      };
      if(im.complete&&im.naturalWidth) go(); else im.addEventListener('load',go,{once:true});
    });
    // article bodies: lists made only of links (Related reading) get the read-more style
    d.querySelectorAll('.f-art__body ul').forEach(function(ul){
      var lis=[].slice.call(ul.children); if(!lis.length) return;
      var ok=lis.every(function(li){ var a=li.querySelector('a'); return a&&li.children.length===1&&li.textContent.trim()===a.textContent.trim(); });
      if(ok) ul.classList.add('f-linklist');
    });
    // store reviews band (below the fold): show only once Judge.me un-hides its carousel
    d.querySelectorAll('.f-jm-store').forEach(function(sec){
      var n=0, t=setInterval(function(){ n++;
        var c=sec.querySelector('.jdgm-cards-carousel');
        if(c&&!c.classList.contains('jdgm-hidden')&&c.offsetHeight>40){ sec.classList.add('has-reviews'); clearInterval(t); }
        else if(n>60) clearInterval(t); },500);
    });
    // reveal
    var els=[].slice.call(d.querySelectorAll('.f-rise'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('f-in'); io.unobserve(e.target);} });},{rootMargin:'0px 0px -6% 0px',threshold:.06});
      els.forEach(function(el){io.observe(el)});
    } else els.forEach(function(el){el.classList.add('f-in')});
    // drawer
    var dr=d.getElementById('f-drawer');
    if(dr){
      var opener=d.querySelector('[data-f-open]');
      function open(){dr.classList.add('is-open');dr.setAttribute('aria-hidden','false');if(opener)opener.setAttribute('aria-expanded','true');d.body.style.overflow='hidden';var c=dr.querySelector('.f-drawer__close'); c&&c.focus();}
      function close(){dr.classList.remove('is-open');dr.setAttribute('aria-hidden','true');if(opener){opener.setAttribute('aria-expanded','false');opener.focus();}d.body.style.overflow='';}
      d.querySelectorAll('[data-f-open]').forEach(function(b){b.addEventListener('click',open)});
      d.querySelectorAll('[data-f-close]').forEach(function(b){b.addEventListener('click',close)});
      d.addEventListener('keydown',function(e){ if(e.key==='Escape'&&dr.classList.contains('is-open')) close(); });
      dr.querySelectorAll('nav a').forEach(function(a){a.addEventListener('click',function(){ if(a.getAttribute('href')&&a.getAttribute('href').charAt(0)==='#'){close();} })});
    }
    // filter tabs
    d.querySelectorAll('[data-f-tabs]').forEach(function(t){
      var target=d.querySelector(t.getAttribute('data-f-tabs'));
      t.querySelectorAll('button').forEach(function(b){ b.addEventListener('click',function(){
        t.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed','false')}); b.setAttribute('aria-pressed','true');
        var v=b.getAttribute('data-v');
        target.querySelectorAll('.f-card').forEach(function(c){ c.hidden = !(v==='all'||c.getAttribute('data-line')===v); });
      });});
    });
    // product views
    d.querySelectorAll('[data-f-views]').forEach(function(box){
      var views=box.querySelectorAll('.f-view'), thumbs=box.querySelectorAll('[data-view]');
      thumbs.forEach(function(t){ t.addEventListener('click',function(){
        var i=t.getAttribute('data-view');
        views.forEach(function(v){ v.classList.toggle('is-on', v.getAttribute('data-i')===i); });
        thumbs.forEach(function(x){ x.setAttribute('aria-current', x===t?'true':'false'); });
      });});
    });
  }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',init); else init();
  window.addEventListener('load',measure);
  if(d.fonts&&d.fonts.ready) d.fonts.ready.then(measure);
})();
